import type { VisibleNavigationSection } from '@Guidelines/Shell/AppShell/Hooks/useVisibleNavigationMenu';
import NavigationMenuItem from '@Guidelines/Shell/AppShell/Menu/NavigationMenu/NavigationMenuItem';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import * as React from 'react';

const labelStyle = css`
	${theme.typography.eyebrow}
	margin: 0 0 0.5rem;
	padding: 0 0.75rem;
	color: ${theme.navigationMenu.sectionLabel};
	text-transform: uppercase;
`;

const listStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
	margin: 0;
	padding: 0;
	list-style: none;
`;

type Props = {
	readonly section: VisibleNavigationSection;
};

/** A section of the menu: an eyebrow label over the list of its entries. */
const NavigationMenuSection: React.FC<Props> = ({ section }) => {
	const labelId = React.useId();

	return (
		<div>
			<div id={labelId} css={labelStyle}>
				{section.label}
			</div>
			<ul css={listStyle} aria-labelledby={labelId}>
				{section.entries.map((item) => (
					<li key={item.entry.id}>
						<NavigationMenuItem item={item} />
					</li>
				))}
			</ul>
		</div>
	);
};

export default NavigationMenuSection;
